export default function NewsHero() {
  return (
    <section className="relative bg-foreground-950 pt-28 md:pt-40 pb-12 md:pb-20 px-4 md:px-8 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20atmospheric%20view%20of%20a%20Southern%20California%20golf%20course%20fairway%20at%20dawn%20with%20soft%20mist%20and%20long%20shadows%2C%20deep%20green%20tones%20with%20dark%20edges%20for%20text%20contrast%2C%20cinematic%20editorial%20photography%2C%20no%20people%20no%20logos&width=1920&height=1080&seq=gs-news-hero&orientation=landscape"
        alt="Golf course at dawn"
        title="GreenSide News stories"
        className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/70 to-foreground-950/40"></div>
      <div className="relative">
        <p className="gs-rise font-label uppercase tracking-[0.25em] text-sm text-accent-400 font-bold">News &amp; Stories</p>
        <h1 className="gs-rise-2 font-heading font-extrabold uppercase text-background-50 text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight mt-2 max-w-5xl">
          The pulse of local golf.
        </h1>
        <p className="gs-rise-3 mt-5 text-background-200 text-base md:text-lg max-w-2xl">
          Community stories, charity spotlights and course coverage from Long Beach and across Southern California.
        </p>
      </div>
    </section>
  );
}